<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Dedication"></h1>
<p class="sectiontop" style="text-align: center;">For all my readers</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?ee313ffc